import React from 'react';
import { Box } from '@mui/material';
import PaginationBar from '../../PaginationBar';

interface ListBottomBarProps {
  page: number;
  count: number;
  onChange?: (e: React.ChangeEvent<unknown>, value: number) => void;
  selectedKeys: string[];
}

const ListBottomBar: React.FC<ListBottomBarProps> = ({ page, count, onChange, selectedKeys }) => {
  const pageCount = Math.max(1, Number(count ?? 1));

  return (
    <Box
      sx={{
        display: 'flex',
        mt: 2,
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      {selectedKeys.length > 0 && <PaginationBar page={page} count={pageCount} onChange={onChange} />}
    </Box>
  );
};

export default ListBottomBar;
